export default "__VITE_ASSET__e571e54a__"